import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sendgrid",
  "use": "sendgrid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"sendgrid\"><path d=\"M2 10.16h3.84V14H2zm7.92 0H6.08V14h3.84zM2 9.92h3.84V6.08H2zm4.08 0h3.84V6.08H6.08zm4.08-4.08H14V2h-3.84zm3.84.24h-3.84v3.84H14zm-7.92-.24h3.84V2H6.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol